/**
 * Shared spotlight positioning utility.
 * Used by CapsheetTour and FeatureTutorial hooks.
 */
export function positionSpotlight(el, { cardId, backdropId, spotlightId, defaultOpacity = 0.55, pad = 10, gap = 16, borderRadius = "12px" }) {
  const targetId = el.dataset.target
  const pos = el.dataset.position
  const card = document.getElementById(cardId)
  const backdrop = document.getElementById(backdropId)
  if (!card || !backdrop) return

  // Remove previous spotlight
  removeSpotlight(spotlightId)

  if (!targetId || pos === "center") {
    card.style.left = "50%"
    card.style.top = "50%"
    card.style.transform = "translate(-50%, -50%)"
    backdrop.style.background = `rgba(0,0,0,${defaultOpacity})`
    return
  }

  const target = document.getElementById(targetId)
  if (!target) {
    card.style.left = "50%"
    card.style.top = "50%"
    card.style.transform = "translate(-50%, -50%)"
    backdrop.style.background = `rgba(0,0,0,${defaultOpacity})`
    return
  }

  backdrop.style.background = "transparent"

  target.scrollIntoView({ behavior: "smooth", block: pos === "center" ? "center" : "nearest" })

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const rect = target.getBoundingClientRect()
      const vw = window.innerWidth
      const vh = window.innerHeight

      const maxSpotW = vw - 16
      const maxSpotH = vh * 0.45
      const spotW = Math.min(rect.width + pad * 2, maxSpotW)
      const spotH = Math.min(rect.height + pad * 2, maxSpotH)

      let spotLeft = rect.left + rect.width / 2 - spotW / 2
      let spotTop = rect.top + rect.height / 2 - spotH / 2
      spotLeft = Math.max(4, Math.min(spotLeft, vw - spotW - 4))
      spotTop = Math.max(4, Math.min(spotTop, vh - spotH - 4))

      const spot = document.createElement("div")
      spot.id = spotlightId
      spot.style.cssText = `
        position: fixed;
        left: ${spotLeft}px;
        top: ${spotTop}px;
        width: ${spotW}px;
        height: ${spotH}px;
        border-radius: ${borderRadius};
        box-shadow: 0 0 0 9999px rgba(0,0,0,${defaultOpacity});
        z-index: 1;
        pointer-events: none;
        transition: all 0.3s ease-out;
      `
      el.insertBefore(spot, card)

      const cardW = card.offsetWidth
      const cardH = card.offsetHeight
      const spotBottom = spotTop + spotH
      const spotRight = spotLeft + spotW

      const spaceBelow = vh - spotBottom - gap
      const spaceAbove = spotTop - gap
      const spaceRight = vw - spotRight - gap
      const spaceLeft = spotLeft - gap

      let left, top

      if (pos === "above" && spaceAbove >= cardH) {
        left = spotLeft + spotW / 2 - cardW / 2
        top = spotTop - gap - cardH
      } else if (pos !== "above" && spaceBelow >= cardH) {
        left = spotLeft + spotW / 2 - cardW / 2
        top = spotBottom + gap
      } else if (spaceBelow >= cardH) {
        left = spotLeft + spotW / 2 - cardW / 2
        top = spotBottom + gap
      } else if (spaceAbove >= cardH) {
        left = spotLeft + spotW / 2 - cardW / 2
        top = spotTop - gap - cardH
      } else if (spaceRight >= cardW) {
        left = spotRight + gap
        top = spotTop + spotH / 2 - cardH / 2
      } else if (spaceLeft >= cardW) {
        left = spotLeft - gap - cardW
        top = spotTop + spotH / 2 - cardH / 2
      } else {
        left = vw / 2 - cardW / 2
        top = vh - cardH - 16
      }

      left = Math.max(8, Math.min(left, vw - cardW - 8))
      top = Math.max(8, Math.min(top, vh - cardH - 8))

      card.style.left = left + "px"
      card.style.top = top + "px"
      card.style.transform = ""
    })
  })
}

export function removeSpotlight(spotlightId) {
  const existing = document.getElementById(spotlightId)
  if (existing) existing.remove()
}
